import { createAction, props } from '@ngrx/store';
import { ProductCategory } from '@warema/shared/company-search/models';

export const LoadProductCategories = createAction('[CompanySearch] Load Product Categories');
export const ProductCategoriesLoaded = createAction(
    '[CompanySearch] Product Categories Loaded',
    props<{ productCategories: Array<ProductCategory> }>(),
);

export const SubProductCategoriesSelected = createAction(
    '[CompanySearch] Sub Product Categories Selected',
    props<{ ids: Array<number> }>(),
);

export const ActivateOnlyOneSubCategory = createAction(
    '[CompanySearch] Only one sub category activated',
    props<{ subProductCategoryId: number }>(),
);

export const deselectAllProductSubCategories = createAction('[CompanySearch] All product subcategories deselected');
